import React, { useEffect, useState } from "react";
import axios from "axios";
import { Star, Truck, ChevronDown, ChevronUp } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StarRow = ({ value, max = 5 }) => {
  const filled = Math.round(Number(value) || 0);
  return (
    <span className="inline-flex items-center gap-0.5">
      {Array.from({ length: max }).map((_, i) => (
        <Star
          key={i}
          className="w-3.5 h-3.5"
          style={{
            fill: i < filled ? "#F59E0B" : "none",
            color: i < filled ? "#F59E0B" : "#D1D5DB",
            strokeWidth: 2,
          }}
        />
      ))}
      <span className="text-xs text-[#5C6E64] ml-1" dir="ltr">{Number(value || 0).toFixed(1)}</span>
    </span>
  );
};

const DriverRatingsTab = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDriver, setOpenDriver] = useState(null);

  useEffect(() => { load(); }, []);
  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/admin/drivers-ratings-summary`);
      setDrivers(data.drivers || []);
    } catch { toast.error("فشل تحميل التقييمات"); }
    finally { setLoading(false); }
  };

  if (loading) return <div className="text-center py-10 text-[#5C6E64]">جاري التحميل...</div>;

  return (
    <div className="space-y-4" dir="rtl">
      <div className="bg-white rounded-2xl border border-[#E4EBE6] p-4">
        <div className="flex items-center gap-2">
          <Truck className="w-5 h-5 text-[#1E3A5F]" />
          <h2 className="font-black text-lg text-[#1E3A5F]">تقييمات السائقين</h2>
        </div>
        <p className="text-xs text-[#5C6E64] mt-1">تقييم الزبائن (الماركتات) لكل سائق. اضغط على السائق لتشاهد تقييم كل ماركت له على حدة.</p>
      </div>
      {drivers.length === 0 ? (
        <div className="text-center py-10 text-[#5C6E64] bg-white rounded-2xl border border-[#E4EBE6]">
          لا يوجد سائقون مسجّلون
        </div>
      ) : (
        <div className="space-y-2">
          {drivers.map((d) => (
            <div key={d.driver_id} className="bg-white rounded-2xl border border-[#E4EBE6] overflow-hidden" data-testid={`driver-rating-${d.driver_id}`}>
              <button
                type="button"
                onClick={() => setOpenDriver(openDriver === d.driver_id ? null : d.driver_id)}
                className="w-full flex items-center justify-between p-4 hover:bg-[#F9FAFB] transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#E0F2FE] flex items-center justify-center">
                    <Truck className="w-5 h-5 text-[#0EA5E9]" />
                  </div>
                  <div className="text-right">
                    <p className="font-black text-[#1E3A5F]">{d.full_name || "—"}</p>
                    <p className="text-xs text-[#5C6E64]" dir="ltr">{d.phone}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-right">
                    {d.avg_rating !== null && d.avg_rating !== undefined ? (
                      <StarRow value={d.avg_rating} />
                    ) : (
                      <span className="text-xs text-[#5C6E64]">لا توجد تقييمات</span>
                    )}
                    <p className="text-[10px] text-[#5C6E64]">{d.total_rated_deliveries} تقييم</p>
                  </div>
                  {openDriver === d.driver_id ? <ChevronUp className="w-4 h-4 text-[#5C6E64]" /> : <ChevronDown className="w-4 h-4 text-[#5C6E64]" />}
                </div>
              </button>
              {openDriver === d.driver_id && (
                <div className="border-t border-[#E4EBE6] p-3 bg-[#F9FAFB]">
                  {d.per_market.length === 0 ? (
                    <p className="text-sm text-[#5C6E64] text-center py-3">لم يقيّمه أي ماركت بعد</p>
                  ) : (
                    <div className="space-y-2">
                      {d.per_market.map((m, i) => (
                        <div key={m.customer_id || i} className="bg-white rounded-xl p-3 flex items-center justify-between border border-[#E4EBE6]">
                          <div className="text-right">
                            <p className="font-bold text-sm text-[#1E3A5F]">{m.market_name || m.user_name || "—"}</p>
                            <p className="text-[10px] text-[#5C6E64]">{m.ratings_count} تقييم</p>
                          </div>
                          <StarRow value={m.avg_rating} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DriverRatingsTab;
